const LESSON_PREFIX = "aninaAcademyLesson:";
const QUIZ_PREFIX = "aninaAcademyQuiz:";

const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const readAcademyProgress = (
  storage = window.localStorage,
  timestamp = new Date().toISOString()
) => {
  try {
    const lessonIds = new Set();

    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (key?.startsWith(LESSON_PREFIX)) lessonIds.add(key.slice(LESSON_PREFIX.length));
      if (key?.startsWith(QUIZ_PREFIX)) lessonIds.add(key.slice(QUIZ_PREFIX.length));
    }

    const records = [...lessonIds].sort().map((lessonId) => {
      const complete = storage.getItem(`${LESSON_PREFIX}${lessonId}`) === "complete";
      const quiz = safeParse(storage.getItem(`${QUIZ_PREFIX}${lessonId}`));

      return {
        id: `academy-progress:${lessonId}`,
        schemaVersion: 1,
        createdAt: timestamp,
        updatedAt: timestamp,
        timestamp,
        archivedAt: null,
        status: "active",
        symbol: null,
        category: "academy-progress",
        source: "academy-local-storage",
        sourceRecordId: `academy:${lessonId}`,
        evidenceStatus: "system-derived",
        confidence: null,
        riskLevel: "none",
        title: `Academy progress: ${lessonId}`,
        details: complete ? "Lesson completed." : "Quiz activity recorded.",
        outcome: quiz
          ? `Quiz score: ${quiz.scorePercent ?? "unknown"}%. ${quiz.passed ? "Passed." : "Not passed."}`
          : "",
        lesson: "",
        tags: ["academy", lessonId],
        userApproved: false,
        dedupeKey: `academy:${lessonId}`,
        readOnly: true,
      };
    });

    return { ok: true, value: records };
  } catch {
    return {
      ok: false,
      error: {
        code: "ACADEMY_STORAGE_READ_FAILED",
        message:
          "Academy progress could not be read from this browser. Existing Academy data was left unchanged.",
      },
    };
  }
};

export default readAcademyProgress;
